/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  function watchNavigationScroll() {
    var st = $(window).scrollTop();

    if( st > 0 ) {
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
    }

    if( $('.section-images-slideshow .images-slideshow, .section-page-banner').length ) {
      var banner_height = $('.section-images-slideshow .images-slideshow, .section-page-banner').eq(0).outerHeight() - $('#header').outerHeight()/2;

      if( st > banner_height ) {
        $('body').addClass('banner-scrolled');
      }
      else {
        $('body').removeClass('banner-scrolled');
      }
    }
  }
  
  function watchSideLines() {
    var wh = $(window).height();
    var st = $(window).scrollTop();

    $('.section-intro-text .side-line').each(function() {
      var top_offset = $(this).offset().top;
      var actual_position = top_offset - st;

      if( actual_position < 0 ) {
        $(this).find('span').css('height', '100%');
      }
      else if( actual_position > wh ) {
        $(this).find('span').css('height', '0');
      }
      else {
        $(this).find('span').css('height', (100 - (actual_position/wh)*100)+'%');
      }
    });
  }

  function isValidSelector(selector) {
    if (typeof(selector) !== 'string') {
        return false;
    }
    try {
        var $element = $(selector);
    } catch(error) {
        return false;
    }
    return true;
}

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        watchNavigationScroll();

        watchSideLines();

        $(window).on('load resize scroll orientationchange', function() {
          watchNavigationScroll();

          watchSideLines();
        });

        $(window).on('scroll', function() {
          $('.bounce-arrow').css('opacity', Math.max(1 - $(window).scrollTop() / 500, 0));
        });

        var wh = $(window).height();

        anime({
          targets: '#navigation .menu > li',
          translateY: wh,
          opacity: [1,0],
          easing: 'linear'
        });

        $(document).on('click', '.menu-toggle', function(e) {
          e.preventDefault();

          var wh = $(window).height();

          $('body').addClass('navigation-animating'); 

          if( $('body').hasClass('navigation-on') ) {
            anime({
              targets: '#navigation .menu > li',
              translateY: wh,
              opacity: [1,0],
              easing: 'linear',
              delay: anime.stagger(50, {direction: 'reverse'}),
              complete: function() {
                $('body').removeClass('navigation-on'); 
              }
            });
          }
          else {
            $('body').addClass('navigation-on');

            anime({
              targets: '#navigation .menu > li',
              translateY: 0,
              opacity: [0,1],
              easing: 'linear',
              delay: anime.stagger(50),
              complete: function() {
                $('body').removeClass('navigation-animating');
              }
            });
          }
        });

        $('.testimonials-carousel').each(function() {
          var t = $(this);

          var atts = {
            dots: true,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: true
          };

          if( t.attr('data-autoplay-slideshow') ) {
            atts.autoplay = true;
          }

          if( t.attr('data-autoplay-speed') ) {
            atts.autoplaySpeed = t.attr('data-autoplay-speed');
          }

          t.slick( atts );
        });

        $('.work-gallery-links').magnificPopup({
          delegate: '.image-link',
          type: 'image',
          closeOnContentClick: false,
          closeBtnInside: false,
          mainClass: 'mfp-with-zoom',
          image: {
            verticalFit: true
          },
          gallery: {
            enabled: true
          },
          zoom: {
            enabled: true,
            duration: 300,
            opener: function(element) {
              return element.closest('article').find('.image-clone');
            }
          }
        });

        $(document).on('click', '.work-gallery .image-link', function(e) {
          e.preventDefault();

          var idx = $(this).attr('data-idx');

          $(this).closest('article').find('.work-gallery-links a[data-idx="'+idx+'"]').trigger('click');
        });


        $('.work-gallery').each(function() {
          var t = $(this);

          var atts = {
            dots: true,
            arrows: true,
            centerMode: true,
            centerPadding: 0,
            variableWidth: true,
            pauseOnHover: false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  centerPadding: '50px',
                  variableWidth: false
                }
              }
            ]
          };

          if( t.attr('data-autoplay-slideshow') ) {
            atts.autoplay = true;
          }

          if( t.attr('data-autoplay-speed') ) {
            atts.autoplaySpeed = t.attr('data-autoplay-speed');
          }

          t.slick( atts );
        });

        $(document).on('click', 'a[href*="#"]', function(e) {
          var split = $(this).attr('href').split('#');

          if( split[1] && isValidSelector( '#' + split[1] ) && !$(e.target).attr('data-toggle') ) {
            var target = $( '#' + split[1] );

            if( target.length ) {
              e.preventDefault();
              $('html,body').stop().animate({
                scrollTop: target.offset().top
              }, 'slow');
            }
          }
        });

        $('[data-vbg]').youtube_background();

        if( $('.section-work-items .work-items').length ) {
          var work_clone = $('.section-work-items .work-items').clone();

          $(document).on('click', '.section-work-items .category-terms input', function() {
            var work_filters_clone = work_clone.clone();

            var categories = ['style', 'type'];

            work_filters_clone.find('.item').each(function() {
              var item = $(this);

              for(var i=0; i<2; i++) {
                if( $('.section-work-items .category-wrapper[data-category="'+categories[i]+'"] input:checked').length ) {
                  var item_has_this_category = false;
                  
                  $('.section-work-items .category-wrapper[data-category="'+categories[i]+'"]').each(function() {
                    var cat = $(this);

                    cat.find('input:checked').each(function() {
                      var cat = categories[i] + '-' + $(this).val();

                      if( item.hasClass( cat ) ) {
                        item_has_this_category = true;
                        return false;
                      }
                    });
                  });

                  if( !item_has_this_category ) {
                    item.remove();
                  }
                }
              }
            });

            $('.section-work-items .work-items').html( work_filters_clone.html() );
          });

          $(document).on('click', '.section-work-items .clear-filters', function(e) {
            e.preventDefault();

            $('.section-work-items input[type="checkbox"]').prop('checked', false);

            $('.section-work-items .work-items').html(work_clone.clone().html() );
          });

          $(document).on('click', '.section-work-items .work-filters-button a, .section-work-items .mobile-hide-filters', function(e) {
            e.preventDefault();

            $('body').toggleClass('work-filters-on');
          });
        }

        AOS.init({
          duration: 1000
        }); //put this line at the end otherwise it conflicts with slick plugin
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
